import React, { useState } from 'react';
import {
    Box,
    Paper,
    Typography,
    Tabs,
    Tab,
    Alert
} from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import SelectCVList from './SelectCVList';
import SelectCVFileListWidget from './SelectCVFileListWidget';

const SelectCVWidget = ({ onCVSelected }) => {
    const [selectedCV, setSelectedCV] = useState(null);
    const [selectedCVFile, setSelectedCVFile] = useState(null);
    const [tabValue, setTabValue] = useState(0);

    const handleCVSelected = (cvData) => {
        if (cvData?.type === 'cv') {
            setSelectedCV(cvData.data);
            setSelectedCVFile(null);
        } else if (cvData?.type === 'cvFile') {
            setSelectedCVFile(cvData.data);
            setSelectedCV(null);
        } else {
            setSelectedCV(null);
            setSelectedCVFile(null);
        }
        onCVSelected(cvData);
    };

    const handleCVFileSelected = (cvFile) => {
        // Wrap the CV file in the expected format
        handleCVSelected({ type: 'cvFile', data: cvFile });
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
        // Clear selections when switching tabs
        if (newValue === 0) {
            setSelectedCVFile(null);
            onCVSelected(null);
        } else {
            setSelectedCV(null);
            onCVSelected(null);
        }
    };

    return (
        <Paper 
            elevation={0}
            sx={{ 
                p: 3,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2
            }}
        >
            <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 3 }}>
                Select or Upload Your CV
            </Typography>

            <Tabs 
                value={tabValue} 
                onChange={handleTabChange}
                sx={{ 
                    mb: 3,
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    '& .MuiTab-root': {
                        textTransform: 'none',
                        fontWeight: 500,
                        minHeight: 48
                    }
                }}
            >
                <Tab 
                    icon={<DescriptionIcon sx={{ fontSize: 20 }} />} 
                    iconPosition="start"
                    label="Choose Existing CV" 
                />
                <Tab 
                    icon={<CloudUploadIcon sx={{ fontSize: 20 }} />} 
                    iconPosition="start"
                    label="Upload New CV" 
                />
            </Tabs>

            <Box sx={{ minHeight: 300 }}>
                {tabValue === 0 ? (
                    <Box>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            Select one of your saved CVs to use for this application
                        </Typography>
                        <SelectCVList 
                            onCVSelected={handleCVSelected}
                            selectedId={selectedCV?.id || selectedCVFile?.id}
                        />
                    </Box>
                ) : (
                    <Box>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            Upload a PDF, DOC, or DOCX file from your computer
                        </Typography>
                        <SelectCVFileListWidget 
                            onCVFileSelected={handleCVFileSelected}
                            selectedId={selectedCVFile?.id}
                        />
                    </Box>
                )}
            </Box>

            {(selectedCV || selectedCVFile) && (
                <Alert 
                    severity="success" 
                    sx={{ mt: 2 }}
                    icon={false}
                >
                    <Typography variant="body2" fontWeight={500}>
                        ✓ Selected: {selectedCV?.title || selectedCVFile?.title || selectedCVFile?.name || 'CV File'}
                    </Typography>
                </Alert>
            )}
        </Paper>
    );
};

export default SelectCVWidget;
